import Marquee from "react-fast-marquee";

export const EditorialMarquee = () => (
  <div className="border-y border-zinc-800 bg-[#0A0A0A] py-5 overflow-hidden" data-testid="editorial-marquee" aria-hidden="true">
    <Marquee speed={28} gradient={false}>
      {Array.from({ length: 6 }).map((_, i) => (
        <span key={i} className="font-oswald uppercase text-2xl md:text-4xl tracking-tight mx-6 flex items-center gap-6">
          <span className="text-outline">Where Good Work</span>
          <span className="text-[#F5C518]">Speaks for Itself</span>
          <span className="text-zinc-700 text-xl">///</span>
        </span>
      ))}
    </Marquee>
  </div>
);
